<template>
  <div class="h-0.5 overflow-hidden" aria-hidden="true">
    <div
      class="h-full w-1/4 bg-n-brand motion-reduce:animate-none animate-report-loading"
    />
  </div>
</template>
